import { AnalyticsRequest, GroupBy, Metric, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { Panel } from '../../models/Panel/Panel';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';

export var TemplateProfile1by3: Panel = {
    id: 'profile-1-by-3',
    name: 'Profiles (3)',
    tags: ['Content', 'Profile', 'Smart', 'landscape', 'portrait'],
    description: '',
    widget: {
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_profile template_profile_1_by_3',
        children: [
            {
                type: 'profile',
                id: '1',
                name: 'profile',
                useGlobalTimePeriod: true,
                profileRequests: [
                    // Note: All global variables like reportingEngine, report, filters, and projections
                    // are injected via AnalyticsRequest.getRequests()
                    new AnalyticsRequest({
                        page: 0,
                        pageSize: 50,
                        groupBys: [
                            new GroupBy({
                                LISTENING: { dimensionName: 'ADVOCATES' },
                            }),
                        ],
                        projections: [
                            new Metric({
                                STORY_MESSAGE: {
                                    dimensionName: 'MENTIONS_COUNT',
                                    heading: 'Mentions',
                                },
                            }),
                        ],
                        sorts: [
                            new Sort({
                                order: 'DESC',
                                heading: {
                                    LISTENING: 'MENTIONS_COUNT',
                                    PLATFORM: 'TOTAL_ENGAGEMENT',
                                    BENCHMARKING: 'TOTAL_ENGAGEMENT',
                                    RDB_FIREHOSE: 'SN_CREATED_TIME',
                                    STORY_MESSAGE: 'MENTIONS_COUNT',
                                },
                            }),
                        ],
                        timePeriod: {
                            key: 'last_7_days',
                        },
                    }) as any,
                ],
                position: {
                    width: '100%',
                    height: '100%',
                    left: '0',
                    top: '0',
                },
                options: {
                    player: {
                        playing: true,
                        duration: 15,
                    },
                    verticalAlign: 'top',
                    numbProfiles: 3,
                    showDescription: true,
                    showIcon: true,

                    showMetricValue: true,
                    metricValueSize: 30,

                    showMetricName: true,
                    metricNameSize: 10,
                    userGroupAvatarSize: 70,
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                    },
                    portrait: {
                        widgetOrientation: 'portrait',
                    },
                },
                label: {
                    titleText: 'Profiles (3)',
                    size: WIDGET_LABEL_SIZE.primary,
                    enabled: true,
                },
            },
        ],
    },
};
